import { Box, Button, Page, Section } from 'ui';

import { FindTicketsTable } from '~/tickets/components/FindTicketsTable/FindTicketsTable';
import { useFindTicketsTitle } from '~/tickets/hooks/useFindTicketsTitle/useFindTicketsTitle';

export const FindTickets = () => {
  const title = useFindTicketsTitle();

  const onOpenIssueClick = () => {
    const url = new URL('/support/ticket/', window.location.href);
    const params = new URLSearchParams(window.location.search);
    params.forEach((value, key) => url.searchParams.set(key, value));
    window.open(url.toString(), '_blank');
  };

  return (
    <Page>
      <Page.Title title={title} />
      <Page.Divider />
      <Section>
        <Box mb={2}>
          <Button onClick={onOpenIssueClick}>Open Issue</Button>
        </Box>
        <FindTicketsTable />
      </Section>
    </Page>
  );
};
